import { render, staticRenderFns } from "./ConsumptionReportWidgetComponent.vue?vue&type=template&id=6a677eaa&"
import script from "./ConsumptionReportWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ConsumptionReportWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports